const nav = {
  init() {
    const nav = document.querySelector('nav');

    if (!nav) return;
    const subnavContainer = document.querySelector('.header__nav-background');

    this.hamburger();
    this.desktopHover(nav, subnavContainer);

    window.addEventListener('resize', () => this.handleResize( nav, subnavContainer ));

    // Shops 
    this.setShopCategories();
  },
  hamburger() {
    const hamburger = document.querySelector('.hamburger');
    const nav = document.querySelector('nav');

    if (!hamburger) return;

    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active');
      nav.classList.toggle('show');
    });
  },
  desktopHover(nav, subnavContainer) {
    this.setSubmenuBackground( nav, subnavContainer );

    const mainChildrens = document.querySelectorAll('.nav-main li.menu-container');

    mainChildrens.forEach( mainChildren => {
      mainChildren.addEventListener('mouseenter', () => {
        subnavContainer.classList.add('active');
        nav.classList.add('active');
      })
    } )

    nav.addEventListener('mouseleave', () => {
      subnavContainer.classList.remove('active');
      nav.classList.remove('active');
    })

  },
  setSubmenuBackground( nav, subnavContainer ) {
    const navHeight = nav.scrollHeight - nav.offsetHeight;
    const hoverElements = document.querySelectorAll('.hover-background');

    subnavContainer.style.height = navHeight + 'px';
    hoverElements.forEach(hoverElement => hoverElement.style.height = navHeight + 'px');
  },
  handleResize(nav, subnavContainer) {
    subnavContainer.removeAttribute('style');
    
    this.setSubmenuBackground(nav, subnavContainer);
  },
  setShopCategories() {
    const shopCategoriesButton = document.querySelector('.shop-categories-button');

    if (!shopCategoriesButton) return;

    const shopCategoriesList = document.querySelector('.shop-categories-list');

    shopCategoriesButton.addEventListener('click', () => {
      shopCategoriesList.classList.toggle('active');
      if (shopCategoriesList.classList.contains('active')) {
        shopCategoriesButton.setAttribute('aria-expanded', 'true');
      } else {
        shopCategoriesButton.setAttribute('aria-expanded', 'false');
      }
    })

    window.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        shopCategoriesList.classList.remove('active');
        shopCategoriesButton.setAttribute('aria-expanded', 'false');
      }
    })

    this.setShopAccordion();
  },
  setShopAccordion() {
    const categoryTitle = document.querySelectorAll(".category-title");

    if ( categoryTitle.length === 0 ) return;

    categoryTitle.forEach(category => {
      category.addEventListener("click", function (event) {
          event.preventDefault();

          let submenu = this.nextElementSibling;
          if (submenu && submenu.classList.contains("submenu")) {
              if ( window.matchMedia('(min-width: 1024px)').matches ) {
                const currentActive = document.querySelector('.submenu.active');
                if ( currentActive && currentActive !== submenu ) {
                  currentActive.classList.remove('active');
                }
                
                const currentActiveCategory = document.querySelector('.category-title.active');

                if ( currentActiveCategory && currentActiveCategory !== category ) {
                  currentActiveCategory.classList.remove('active');
                }

                submenu.classList.toggle('active');
                category.classList.toggle('active');
              } else {
                if (submenu.style.maxHeight) {
                    submenu.style.maxHeight = null;
                } else {
                    submenu.style.maxHeight = submenu.scrollHeight + "px";
                }
              }

          }
      });
    });
  }
};

export default nav;
